module.exports = __webpack_public_path__ + "static/media/sohoj-bd-new.5e89c473.jpg";